module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAb1BMVEUAAAAuLzYuLzYuLzYuLzZhqEIuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzZhqELsexxsAAAAI3RSTlMA8a0nGMT0+7cI4bVqJRwM1OvOx6aCY0Tl2r+dl5BZV1E1Ilb4MdYAAACwSURBVCjPrZBJEoMgEEWZIuKEs5mn7/3PGJECSblgkbwNv/tVFw3kB0pGKSuD5OEUC5QHycGQCpGCBclBIQgRSMIUVwy5qHKwLcXWsM6szL9SHD3UUmb9k6gxPUp5uvoxnsHSuSALa1SNbtKaF4to72+lXhfAugK1WkMP3MjKiKQy5xkP22jQMP/Swf5FtVtsQmsOgJDDYWubQiNxap69sAXgVYhV0an9XZvaA5C/8wEKfBOrRoSBUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zskx_green.png
// module id = GFPs
// module chunks = 101